(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["case-card"] && !Shopify.designMode) return;
  try {
    (function () {
    // Sizes each MacBook scroller from its screenshot's real aspect ratio so the
    // travel distance matches the image instead of a guessed percentage.
    //
    // what-section defines the same initialiser. Whichever runs first wins and
    // the other just calls init() — the guard makes it idempotent, and init()
    // scans the whole document, so a section can pick up another's scrollers.
    // Both files carry a copy deliberately: either can appear without the other.
    if (window.UMGWhatDevices) { window.UMGWhatDevices.init(); return; }

    function fitScroller(scroller) {
      var img = scroller.querySelector('img');
      var viewport = scroller.parentElement;
      if (!img || !viewport) return;

      function apply() {
        var iw = img.naturalWidth, ih = img.naturalHeight;
        var vw = viewport.clientWidth, vh = viewport.clientHeight;
        if (!iw || !ih || !vw || !vh) return;

        // Height of the image once its width fills the viewport.
        var scaledH = (ih / iw) * vw;
        if (scaledH <= vh + 1) {
          scroller.style.setProperty('--wd-scroll-h', '100%');
          scroller.style.setProperty('--wd-scroll-end', '0%');
          return;
        }
        var heightPct = (scaledH / vh) * 100;
        scroller.style.setProperty('--wd-scroll-h', heightPct.toFixed(2) + '%');
        scroller.style.setProperty('--wd-scroll-end', (-(1 - 100 / heightPct) * 100).toFixed(2) + '%');
      }

      if (img.complete) { apply(); } else { img.addEventListener('load', apply, { once: true }); }
      return apply;
    }

    function initDevices(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var scrollers = scope.querySelectorAll('[data-wd-scroll]');
      var appliers = [];
      Array.prototype.forEach.call(scrollers, function (s) {
        if (s.dataset.wdBound === 'true') return;
        s.dataset.wdBound = 'true';
        var a = fitScroller(s);
        if (a) appliers.push(a);
      });
      if (appliers.length && !window.UMGWhatDevices._resizeBound) {
        window.UMGWhatDevices._resizeBound = true;
        var t;
        window.addEventListener('resize', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            document.querySelectorAll('[data-wd-scroll]').forEach(fitScroller);
          }, 150);
        });
      }
    }

    window.UMGWhatDevices = { init: initDevices, _resizeBound: false };

    document.addEventListener('DOMContentLoaded', function () { initDevices(); });
    document.addEventListener('shopify:section:load', function (e) { initDevices(e.target); });
    initDevices();
  })();

  (function () {
    // Counts the metric chips up when a card scrolls into view. The number is
    // the element's last text node (the glyph is a leading child), so only that
    // node is rewritten and the markup survives.
    function animate(el) {
      var textNode = el.lastChild;
      if (!textNode || textNode.nodeType !== 3) return;

      var raw = (textNode.nodeValue || '').trim();
      var m = raw.match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!m) return;

      var prefix = m[1];
      var numStr = m[2].replace(/,/g, '');
      var suffix = m[3];
      var target = parseFloat(numStr);
      if (isNaN(target)) return;

      var dot = numStr.indexOf('.');
      var dec = dot === -1 ? 0 : numStr.length - dot - 1;

      function fmt(v) {
        return prefix + v.toFixed(dec) + suffix;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        textNode.nodeValue = fmt(target);
        return;
      }

      var duration = 1500;
      var start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        textNode.nodeValue = fmt(target * eased);
        if (progress < 1) requestAnimationFrame(step);
        else textNode.nodeValue = fmt(target);
      }

      requestAnimationFrame(step);
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var chips = scope.querySelectorAll('.case-card__chip-num[data-chip-count]');

      Array.prototype.forEach.call(chips, function (el) {
        if (el.dataset.chipBound === '1') return;
        el.dataset.chipBound = '1';

        if (!('IntersectionObserver' in window)) {
          animate(el);
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                animate(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.6 }
        );

        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["case-grid"] && !Shopify.designMode) return;
  try {
    /* Duplicates the cards once so the -50% translate lands exactly on the start
     of the second copy. Clones are decorative: hidden from assistive tech, and
     stripped of ids and of any "already bound" flags so per-card scripts still
     initialise them rather than skipping them as seen. */
  (function () {
    function build(track) {
      if (track.dataset.casesCloned === '1') return;
      track.dataset.casesCloned = '1';

      var cards = [].slice.call(track.children);
      if (!cards.length) return;

      cards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('data-cases-clone', '');
        clone.removeAttribute('id');
        [].slice.call(clone.querySelectorAll('[id]')).forEach(function (el) { el.removeAttribute('id'); });
        [].slice.call(clone.querySelectorAll('*')).concat([clone]).forEach(function (el) {
          Object.keys(el.dataset || {}).forEach(function (k) {
            if (/bound|cloned/i.test(k)) delete el.dataset[k];
          });
        });
        track.appendChild(clone);
      });
    }

    /* Stepped auto-advance on phones (Brady): hold, move one card, hold again —
       deliberately NOT the continuous marquee the desktop row uses.

       Only runs where the row is a snap scroller (<=700px). It drives
       scrollLeft rather than a transform so the native snap points, the
       scrollbar position and a user's own swipe all stay in agreement. Any
       manual interaction backs it off for one full dwell so it never fights
       the thumb, and it pauses off-screen and under reduced-motion. */
    var HOLD = 4000;

    function autoStep(rail) {
      if (rail.dataset.casesStepBound === '1') return;
      rail.dataset.casesStepBound = '1';

      var mq = window.matchMedia('(max-width: 700px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var timer = null, visible = false, held = 0;

      function cardWidth() {
        var first = rail.querySelector('.shopify-block:not([data-cases-clone])');
        if (!first) return rail.clientWidth;
        var style = getComputedStyle(first.parentElement);
        return first.getBoundingClientRect().width + (parseFloat(style.columnGap || style.gap) || 0);
      }

      function step() {
        if (Date.now() < held) return;
        var w = cardWidth();
        var max = rail.scrollWidth - rail.clientWidth;
        /* Wrap only once we are ALREADY at the end, and clamp the last hop to
           max. Wrapping as soon as the next position would exceed max skipped
           the final card entirely: with 4 cards the stops are 0/380/760/1140
           but max is 1125, so 760 + 380 overshot and jumped straight back to 0
           without the last card ever getting its turn. The 2px slack absorbs
           sub-pixel widths, which otherwise leave it a hair short of max and
           never wrapping at all. */
        if (rail.scrollLeft >= max - 2) {
          rail.scrollTo({ left: 0, behavior: 'smooth' });
          return;
        }
        rail.scrollTo({ left: Math.min(rail.scrollLeft + w, max), behavior: 'smooth' });
      }

      function start() {
        if (timer || !visible || reduce.matches || !mq.matches) return;
        timer = setInterval(step, HOLD);
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      function defer() { held = Date.now() + HOLD; }

      ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
        rail.addEventListener(evt, defer, { passive: true });
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            visible = e.isIntersecting;
            if (visible) start(); else stop();
          });
        }, { threshold: 0.25 }).observe(rail);
      } else {
        visible = true; start();
      }

      function sync() { stop(); start(); }
      (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(sync);
      (reduce.addEventListener ? reduce.addEventListener.bind(reduce, 'change') : reduce.addListener.bind(reduce))(sync);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-cases-track]').forEach(build);
      (scope || document).querySelectorAll('[data-cases-marquee]').forEach(autoStep);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-newsletter"] && !Shopify.designMode) return;
  try {
    /* Posts the address to Klaviyo's client subscriptions endpoint and reports back in
     place. The endpoint answers 202 with an empty body and does the rest out of band,
     so "accepted" is all the page can honestly say. The list this points at is single
     opt-in, so accepted does mean subscribed; a double opt-in list would still have to
     send its confirmation first, which is what the success message setting is for. */
  (function () {
    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
    var REVISION = '2026-07-15';

    function say(form, message, isError) {
      var status = form.querySelector('[data-news-status]');
      if (!status) return;
      status.textContent = message || '';
      if (isError) status.setAttribute('data-news-error', '');
      else status.removeAttribute('data-news-error');
    }

    function submit(form, email) {
      return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(form.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
          }
        })
      });
    }

    function bind(form) {
      if (form.dataset.newsBound === '1') return;
      form.dataset.newsBound = '1';

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        var input = form.querySelector('input[type="email"]');
        var button = form.querySelector('button[type="submit"]');
        var email = (input.value || '').trim();

        if (!email || !input.checkValidity()) {
          say(form, form.dataset.invalid, true);
          input.focus();
          return;
        }

        /* The customizer renders the real form; submitting from it would put the
           person editing the page onto the list. */
        if (window.Shopify && window.Shopify.designMode) {
          say(form, form.dataset.success, false);
          return;
        }

        button.disabled = true;
        say(form, '', false);

        submit(form, email)
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            form.classList.add('is-done');
            say(form, form.dataset.success, false);
            document.dispatchEvent(new CustomEvent('umg:newsletter', { detail: { source: 'footer' } }));
          })
          .catch(function () {
            say(form, form.dataset.error, true);
            button.disabled = false;
          });
      });
    }

    function init() {
      [].slice.call(document.querySelectorAll('form[data-newsletter]')).forEach(bind);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["growth-outputs"] && !Shopify.designMode) return;
  try {
    /* Traffic -> revenue pipeline. Ported from the design's script, with three
     changes: gate text is read from the growth-output-item blocks instead of a
     hardcoded array, the instance is scoped via data-attributes so more than
     one can coexist, and it boots on the theme's section-load event.

     The SVG is generated rather than authored — do not hand-maintain its
     output. Two builds: horizontal above 1100px, vertical at or below. */
  (function () {
    var TRAVEL = 3000, HOLD = 1700, PASSES = 3;
    var PCT = [12, 26, 38], LVL = [0.42, 0.72, 1];
    var TREND = '<path d="m22 7-8.5 8.5-5-5L2 17"/><path d="M16 7h6v6"/>';
    var POD_ICONS = {
      cart: '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>',
      mail: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-10 5L2 7"/>',
      repeat: '<path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>',
      chart: '<path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/>'
    };

    function esc(v) {
      return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function pod(x, y, icon, d) {
      return '<g class="pl-pod" transform="translate(' + x + ',' + y + ')"><g class="pl-pod-anim" style="--pd:' + d + 's">'
        + '<rect x="-17" y="-17" width="34" height="34" rx="10"/>'
        + '<g class="pl-pod-i" transform="translate(-8,-8) scale(0.66)">' + POD_ICONS[icon] + '</g></g></g>';
    }

    function pop(tx, ty, w, icon, barW) {
      return '<g class="pg-arr"><g class="pg-pop" transform="translate(' + tx + ',' + ty + ')">'
        + '<rect x="0" y="0" width="' + w + '" height="21" rx="10.5"/>'
        + '<g class="pg-pop-i" transform="translate(6,4) scale(0.55)">' + icon + '</g>'
        + '<rect class="pg-pop-bar" x="24" y="7.5" width="' + barW + '" height="6" rx="3"/></g></g>';
    }

    var VIG = [
      '<circle class="pg-dot" cx="-63" cy="-46" r="2.2"/><circle class="pg-dot" cx="-55" cy="-46" r="2.2"/><circle class="pg-dot" cx="-47" cy="-46" r="2.2"/>'
        + '<rect class="pg-sk" x="-38" y="-50" width="58" height="8" rx="4"/>'
        + '<rect class="pg-mini" x="-63" y="-32" width="46" height="34" rx="7"/>'
        + '<rect class="pg-sk-b" x="-9" y="-30" width="50" height="8" rx="4"/>'
        + '<rect class="pg-sk" x="-9" y="-17" width="34" height="6" rx="3"/>'
        + '<rect class="pg-sk" x="-63" y="8" width="46" height="6" rx="3"/>'
        + pop(-9, 14, 72, POD_ICONS.cart, 42),
      '<rect class="pg-mini" x="-65" y="-52" width="58" height="17" rx="8.5"/><rect class="pg-sk-b" x="-57" y="-47" width="42" height="6" rx="3"/>'
        + '<path class="pg-line" d="M-58 -35 V 14"/>'
        + '<rect class="pg-mini" x="-50" y="-28" width="102" height="28" rx="8"/><circle class="pg-avatar" cx="-35" cy="-14" r="8"/><g class="pg-pop-i" transform="translate(-40.5,-19.5) scale(0.46)">' + POD_ICONS.mail + '</g>'
        + '<rect class="pg-sk-b" x="-22" y="-20" width="54" height="5" rx="2.5"/><rect class="pg-sk" x="-22" y="-12" width="66" height="4" rx="2"/>'
        + '<rect class="pg-mini" x="-2" y="8" width="60" height="18" rx="9"/><rect class="pg-sk" x="6" y="14" width="42" height="5" rx="2.5"/>'
        + pop(-65, 32, 60, POD_ICONS.chart, 30),
      '<path class="pg-line" d="M-58 40 H 58"/>'
        + '<rect class="pg-barw" x="-52" y="12" width="18" height="28" rx="4"/>'
        + '<rect class="pg-barw" x="-26" y="-2" width="18" height="42" rx="4"/>'
        + '<rect class="pg-barw" x="0" y="-16" width="18" height="56" rx="4"/>'
        + '<rect x="26" y="-32" width="18" height="72" rx="4" fill="url(#plBar)"/>'
        + pop(-6, -52, 58, TREND, 28)
    ];

    function build(root) {
      var wrap = root.querySelector('[data-pipeline]');
      if (!wrap) return;

      /* Gate copy comes from the blocks. Falls back to the design's values so
         the diagram still draws if a block is emptied in the editor. */
      var GATES = [].slice.call(root.querySelectorAll('[data-gate]')).map(function (el) {
        return [el.getAttribute('data-name') || '', el.getAttribute('data-verb') || '', el.getAttribute('data-chip') || ''];
      });
      if (GATES.length !== 3) {
        GATES = [['Conversion', 'increases', '+CVR'], ['Retention', 'improves', '+LTV'], ['Revenue', 'compounds', '+AOV']];
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var geo, gatePos, gates, fills, rings, pings, chips, arrs, bar, lit, pulseG, pctEl, svg;
      var raf = null, t0 = 0, vertical = null, running = false;

      function gate(x, y, i, s) {
        var hw = 85 * s, hh = 67 * s;
        return '<g class="pg" transform="translate(' + x + ',' + y + ')"><g transform="scale(' + s + ')">'
          + '<rect class="pg-box" x="-85" y="-67" width="170" height="134" rx="18"/>'
          + '<rect class="pg-fill" x="-85" y="-67" width="170" height="134" rx="18"/>'
          + '<rect class="pg-ring" x="-85" y="-67" width="170" height="134" rx="18"/>'
          + VIG[i] + '</g></g>'
          + '<g class="pg-ping-g" transform="translate(' + x + ',' + y + ')" opacity="0"><rect class="pg-ping" x="-' + hw.toFixed(1) + '" y="-' + hh.toFixed(1) + '" width="' + (hw * 2).toFixed(1) + '" height="' + (hh * 2).toFixed(1) + '" rx="' + (18 * s).toFixed(1) + '"/></g>';
      }

      function draw(v) {
        var i, g, s;
        var grad = v
          ? '<linearGradient id="plBar" x1="0" y1="0" x2="1" y2="0">'
          : '<linearGradient id="plBar" x1="0" y1="1" x2="0" y2="0">';
        var defs = '<defs>' + grad
          + '<stop offset="0" stop-color="#009882" stop-opacity=".38"/><stop offset="1" stop-color="#00B29D"/></linearGradient>'
          + '<radialGradient id="plGlow"><stop offset="0" stop-color="#00B29D" stop-opacity=".5"/>'
          + '<stop offset="1" stop-color="#009882" stop-opacity="0"/></radialGradient></defs>';
        gatePos = [];

        if (!v) {
          var gx = [317, 575, 834];
          geo = { v: false, x0: 82, y0: 130, x1: 1078, y1: 130, gf: [], cx: 1092, cy: 130, cr0: 10, cr1: 44 };
          var mh = '<mask id="plMask" maskUnits="userSpaceOnUse" x="0" y="0" width="1200" height="300"><rect x="0" y="0" width="1200" height="300" fill="#fff"/>';
          for (i = 0; i < 3; i++) mh += '<rect x="' + (gx[i] - 97) + '" y="53" width="194" height="150" rx="20" fill="#000"/>';
          mh += '</mask>';
          s = '<svg viewBox="0 14 1200 268" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + defs + mh
            + '<g mask="url(#plMask)"><path class="pl-track" d="M82 130H1078"/><path class="pl-lit" d="M82 130H1078"/>'
            + '<g class="pl-pulse-g" opacity="0"><circle class="pl-pulse-glow" r="17"/><circle class="pl-pulse" r="5"/><circle class="pl-pulse-core" r="2.2"/></g></g>';
          for (i = 0; i < 3; i++) {
            g = gx[i];
            geo.gf.push((g - 82) / 996);
            gatePos.push([g, 130]);
            s += gate(g, 130, i, 1.12)
              + '<g class="pg-chip" transform="translate(' + g + ',38)" opacity="0"><rect x="-33" y="-14" width="66" height="27" rx="13.5"/><text y="4.5" text-anchor="middle" font-size="13">' + esc(GATES[i][2]) + '</text></g>'
              + '<text class="pl-name" x="' + g + '" y="240" text-anchor="middle" font-size="26">' + esc(GATES[i][0]) + '</text>'
              + '<text class="pl-verb" x="' + g + '" y="266" text-anchor="middle" font-size="15">' + esc(GATES[i][1]) + '</text>';
          }
          s += '<circle class="pl-src" cx="58" cy="130" r="14"/><circle class="pl-src-i" cx="58" cy="130" r="5"/>'
            + '<text class="pl-cap" x="58" y="240" text-anchor="middle" font-size="15">Traffic</text>'
            + '<circle class="po-bar" cx="1092" cy="130" r="10" stroke="rgba(255,255,255,0.35)" stroke-width="1.5"/>'
            + '<text class="po-pct" x="1092" y="104" text-anchor="middle" font-size="21" opacity="0">+38%</text>'
            + '<text class="pl-cap" x="1092" y="240" text-anchor="middle" font-size="15">Compounding</text>'
            + '<text class="pl-cap" x="1092" y="262" text-anchor="middle" font-size="15">revenue</text>'
            + '<circle class="pl-node" cx="152" cy="130" r="3.5"/><circle class="pl-node" cx="446" cy="130" r="3.5"/><circle class="pl-node" cx="705" cy="130" r="3.5"/><circle class="pl-node" cx="984" cy="130" r="3.5"/>'
            + '<path class="pl-tick" d="M102 124v12M202 124v12M416 124v12M476 124v12M675 124v12M735 124v12M954 124v12M1014 124v12"/>'
            + pod(152, 78, 'cart', 0.2) + pod(446, 78, 'mail', 1.4) + pod(705, 78, 'repeat', 2.6) + pod(984, 82, 'chart', 3.4);
        } else {
          var gy = [120, 228, 336];
          geo = { v: true, x0: 72, y0: 54, x1: 72, y1: 424, gf: [], cx: 72, cy: 436, cr0: 8, cr1: 30 };
          var mv = '<mask id="plMask" maskUnits="userSpaceOnUse" x="0" y="0" width="380" height="500"><rect x="0" y="0" width="380" height="500" fill="#fff"/>';
          for (i = 0; i < 3; i++) mv += '<rect x="19" y="' + (gy[i] - 42) + '" width="106" height="84" rx="12" fill="#000"/>';
          mv += '</mask>';
          s = '<svg viewBox="0 14 380 480" preserveAspectRatio="xMidYMid meet" aria-hidden="true">' + defs + mv
            + '<g mask="url(#plMask)"><path class="pl-track" d="M72 54V424"/><path class="pl-lit" d="M72 54V424"/>'
            + '<g class="pl-pulse-g" opacity="0"><circle class="pl-pulse-glow" r="14"/><circle class="pl-pulse" r="4.5"/><circle class="pl-pulse-core" r="2"/></g></g>';
          for (i = 0; i < 3; i++) {
            g = gy[i];
            geo.gf.push((g - 54) / 370);
            gatePos.push([72, g]);
            s += gate(72, g, i, 0.62)
              + '<g class="pg-chip" transform="translate(292,' + (g + 4) + ')" opacity="0"><rect x="0" y="-13.5" width="62" height="27" rx="13.5"/><text x="31" y="4.5" text-anchor="middle" font-size="12">' + esc(GATES[i][2]) + '</text></g>'
              + '<text class="pl-name" x="152" y="' + (g - 2) + '" font-size="24">' + esc(GATES[i][0]) + '</text>'
              + '<text class="pl-verb" x="152" y="' + (g + 22) + '" font-size="14">' + esc(GATES[i][1]) + '</text>';
          }
          s += '<circle class="pl-src" cx="72" cy="34" r="12"/><circle class="pl-src-i" cx="72" cy="34" r="4.5"/>'
            + '<text class="pl-cap" x="98" y="39" font-size="14">Traffic</text>'
            + '<circle class="po-bar" cx="72" cy="436" r="8" stroke="rgba(255,255,255,0.35)" stroke-width="1.5"/>'
            + '<text class="po-pct" x="92" y="441" font-size="18" opacity="0">+38%</text>'
            + '<text class="pl-cap" x="36" y="486" font-size="14">Compounding revenue</text>'
            + '<circle class="pl-node" cx="72" cy="174" r="3"/><circle class="pl-node" cx="72" cy="282" r="3"/>';
        }
        s += '</svg>';

        wrap.classList.toggle('is-stack', !!v);
        wrap.innerHTML = s;
        svg = wrap.querySelector('svg');
        gates = [].slice.call(svg.querySelectorAll('.pg'));
        fills = [].slice.call(svg.querySelectorAll('.pg-fill'));
        rings = [].slice.call(svg.querySelectorAll('.pg-ring'));
        pings = [].slice.call(svg.querySelectorAll('.pg-ping-g'));
        chips = [].slice.call(svg.querySelectorAll('.pg-chip'));
        arrs = [].slice.call(svg.querySelectorAll('.pg-arr'));
        bar = svg.querySelector('.po-bar');
        lit = svg.querySelector('.pl-lit');
        pulseG = svg.querySelector('.pl-pulse-g');
        pctEl = svg.querySelector('.po-pct');
        geo.len = Math.abs(geo.x1 - geo.x0) + Math.abs(geo.y1 - geo.y0);
        lit.setAttribute('stroke-dasharray', geo.len + ' ' + geo.len);
        lit.setAttribute('stroke-dashoffset', geo.len);
        if (reduce) settle();
      }

      function setBar(lvl) {
        var r = geo.cr0 + (geo.cr1 - geo.cr0) * lvl;
        bar.setAttribute('r', r.toFixed(1));
        if (geo.v) pctEl.setAttribute('x', (geo.cx + r + 12).toFixed(1));
        else pctEl.setAttribute('y', (geo.cy - r - 16).toFixed(1));
      }

      function ez(x) { x = Math.max(0, Math.min(1, x)); return x * x * (3 - 2 * x); }

      function settle() {
        for (var i = 0; i < 3; i++) {
          fills[i].setAttribute('opacity', '0.13');
          rings[i].setAttribute('opacity', '0.45');
        }
        lit.setAttribute('stroke-dashoffset', 0);
        setBar(1);
        pctEl.textContent = '+' + PCT[PASSES - 1] + '%';
        pctEl.setAttribute('opacity', '0.9');
      }

      function frame(ts) {
        if (!t0) t0 = ts;
        var t = ts - t0, cyc = PASSES * TRAVEL + HOLD, tc = t % cyc;
        var inHold = tc >= PASSES * TRAVEL;
        var pass = inHold ? PASSES - 1 : Math.floor(tc / TRAVEL);
        var u = inHold ? 1 : (tc % TRAVEL) / TRAVEL;
        var ue = ez(u), i;

        var px = geo.x0 + (geo.x1 - geo.x0) * ue, py = geo.y0 + (geo.y1 - geo.y0) * ue;
        pulseG.setAttribute('transform', 'translate(' + px.toFixed(1) + ',' + py.toFixed(1) + ')');
        pulseG.setAttribute('opacity', inHold ? '0' : (u < 0.03 ? (u / 0.03).toFixed(2) : u > 0.97 ? ((1 - u) / 0.03).toFixed(2) : '1'));
        lit.setAttribute('stroke-dashoffset', (geo.len * (1 - ue)).toFixed(1));
        lit.setAttribute('opacity', inHold ? '0.35' : '0.8');

        for (i = 0; i < 3; i++) {
          var f = geo.gf[i], crossed = ue >= f;
          var d = Math.abs(ue - f), c = d < 0.05 ? ez(1 - d / 0.05) : 0;
          fills[i].setAttribute('opacity', ((crossed ? 0.12 : 0.03) + 0.22 * c).toFixed(3));
          rings[i].setAttribute('opacity', ((crossed ? 0.45 : 0.10) + 0.5 * c).toFixed(3));
          gates[i].setAttribute('transform', 'translate(' + gatePos[i][0] + ',' + gatePos[i][1] + ') scale(' + (1 + 0.05 * c).toFixed(4) + ')');
          arrs[i].setAttribute('transform', 'translate(0,' + (-4 * c).toFixed(2) + ')');
          var pp = (ue - f) / 0.11;
          if (pp > 0 && pp < 1) {
            pings[i].setAttribute('opacity', (0.85 * (1 - pp)).toFixed(2));
            pings[i].setAttribute('transform', 'translate(' + gatePos[i][0] + ',' + gatePos[i][1] + ') scale(' + (1 + 0.42 * pp).toFixed(3) + ')');
          } else {
            pings[i].setAttribute('opacity', '0');
          }
          var rise = ez((ue - f) / 0.025), fall = ez(1 - (ue - f - 0.40) / 0.09);
          var vis = crossed && !inHold ? Math.min(rise, fall) : 0;
          chips[i].setAttribute('opacity', vis.toFixed(2));
          var base = chips[i].getAttribute('data-b');
          if (!base) { base = chips[i].getAttribute('transform'); chips[i].setAttribute('data-b', base); }
          chips[i].setAttribute('transform', base + ' translate(0,' + (6 * (1 - Math.min(1, rise))).toFixed(1) + ')');
        }

        var b0 = pass > 0 ? LVL[pass - 1] : 0, p0 = pass > 0 ? PCT[pass - 1] : 0;
        var gp = ez((ue - 0.9) / 0.1);
        var lvl = b0 + (LVL[pass] - b0) * gp;
        var pv = Math.round(p0 + (PCT[pass] - p0) * gp);
        var popOp = lvl > 0.02 ? 0.9 : 0;
        if (inHold) {
          var th = tc - PASSES * TRAVEL;
          if (th > HOLD - 500) {
            var k = (th - (HOLD - 500)) / 500;
            lvl = 1 - ez(k);
            popOp = 0.9 * (1 - k);
          } else { lvl = 1; }
          pv = PCT[PASSES - 1];
        }
        setBar(lvl);
        pctEl.textContent = '+' + pv + '%';
        pctEl.setAttribute('opacity', popOp.toFixed(2));

        raf = requestAnimationFrame(frame);
      }

      function play() { if (running || reduce) return; running = true; t0 = 0; raf = requestAnimationFrame(frame); }
      function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = null; }

      function sync() {
        var v = window.innerWidth <= 1100;
        if (v === vertical) return;
        vertical = v;
        var was = running;
        stop();
        draw(v);
        if (was) play();
      }

      sync();
      var tid;
      window.addEventListener('resize', function () { clearTimeout(tid); tid = setTimeout(sync, 160); });

      if (!('IntersectionObserver' in window)) { play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) play(); else stop(); });
      }, { threshold: 0.2 }).observe(wrap);
    }

    function init(scope) {
      (scope || document).querySelectorAll('.growth-outputs').forEach(function (root) {
        if (root.dataset.pipelineBound === '1') return;
        root.dataset.pipelineBound = '1';
        build(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["problem-list"] && !Shopify.designMode) return;
  try {
    /* Lit sweep. Items light in sequence, hold, clear, repeat — restarted by an
     IntersectionObserver so it only runs while the list is on screen.

     Scoped per instance via data-attributes, and the timers are tracked so
     scrolling away cancels them instead of leaving a stack of pending
     timeouts that all fire at once on return. */
  (function () {
    var STEP = 850;
    var HOLD = 1600;
    var FADE = 900;
    var LEAD = 400;

    function build(list) {
      if (list.dataset.problemLitBound === '1') return;
      list.dataset.problemLitBound = '1';

      /* Shopify wraps every block in a .shopify-block, so the items are
         grandchildren of the grid, not children — query for them directly. */
      var items = list.querySelectorAll('.problem-item');
      if (!items.length) return;

      function litAll() {
        items.forEach(function (el) { el.classList.add('lit'); });
      }

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        litAll();
        return;
      }

      var timers = [];
      var running = false;

      function clearTimers() {
        timers.forEach(clearTimeout);
        timers = [];
      }

      function cycle() {
        items.forEach(function (el, i) {
          timers.push(setTimeout(function () { el.classList.add('lit'); }, LEAD + i * STEP));
        });

        var end = LEAD + items.length * STEP + HOLD;

        timers.push(setTimeout(function () {
          items.forEach(function (el) { el.classList.remove('lit'); });
        }, end));

        timers.push(setTimeout(cycle, end + FADE));
      }

      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !running) {
            running = true;
            cycle();
          } else if (!e.isIntersecting && running) {
            running = false;
            clearTimers();
          }
        });
      }, { threshold: 0.35 }).observe(list);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-problem-list]').forEach(build);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["result-stat"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Both the card figure and the revenue banner carry data-count-up, and
       they use different class names — match on the attribute alone. */
    var SEL = '[data-count-up]';

    // "$200,000,000.00+" -> {prefix:"$", target:200000000, suffix:"+", dec:2}
    // "$200M+"           -> {prefix:"$", target:200,       suffix:"M+", dec:0}
    function parse(raw) {
      var m = String(raw).trim().match(/^([^\d]*)([\d.,]+)(.*)$/);
      if (!m) return null;
      var numStr = m[2].replace(/,/g, '');
      var target = parseFloat(numStr);
      if (isNaN(target)) return null;
      var dot = numStr.indexOf('.');
      return {
        prefix: m[1],
        suffix: m[3],
        target: target,
        dec: dot === -1 ? 0 : numStr.length - dot - 1
      };
    }

    function fmt(value, dec, prefix, suffix) {
      var s = Number(value).toLocaleString('en-US', {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec
      });
      return prefix + s + suffix;
    }

    function run(el) {
      var isMobile = window.matchMedia('(max-width: 700px)').matches;
      var mobileRaw = el.getAttribute('data-count-mobile');
      var raw = isMobile && mobileRaw ? mobileRaw : el.getAttribute('data-count-raw');
      var p = parse(raw);

      if (!p) {
        el.textContent = raw;
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = fmt(p.target, p.dec, p.prefix, p.suffix);
        return;
      }

      var duration = 1900;
      var start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = fmt(p.target * eased, p.dec, p.prefix, p.suffix);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = fmt(p.target, p.dec, p.prefix, p.suffix);
        }
      }

      requestAnimationFrame(step);
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var els = scope.querySelectorAll(SEL);

      Array.prototype.forEach.call(els, function (el) {
        if (el.dataset.countBound === '1') return;
        el.dataset.countBound = '1';
        // Capture the authored value before any animation overwrites it.
        el.setAttribute('data-count-raw', el.textContent.trim());

        if (!('IntersectionObserver' in window)) {
          run(el);
          return;
        }

        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                run(entry.target);
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.45 }
        );

        io.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["service-tile"] && !Shopify.designMode) return;
  try {
    (function () {
    var SEL = 'video[data-sv-video]';

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function load(video) {
      if (video.dataset.svLoaded === '1') return;
      video.dataset.svLoaded = '1';
      video.src = video.dataset.src;
      // Under reduced motion the video still loads so the card shows its first
      // frame, but it never plays.
      video.preload = reduceMotion ? 'metadata' : 'auto';
      video.load();
    }

    function play(video) {
      if (reduceMotion) return;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function init(root) {
      var scope = root && root.querySelectorAll ? root : document;
      var videos = scope.querySelectorAll(SEL);

      Array.prototype.forEach.call(videos, function (video) {
        if (video.dataset.svBound === '1') return;
        video.dataset.svBound = '1';

        if (!('IntersectionObserver' in window)) {
          load(video);
          play(video);
          return;
        }

        // Load a little before the card arrives; pause once it leaves so six
        // looping videos don't all decode at once.
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                load(entry.target);
                play(entry.target);
              } else if (entry.target.dataset.svLoaded === '1') {
                entry.target.pause();
              }
            });
          },
          { rootMargin: '200px 0px' }
        );

        io.observe(video);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
